<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Payment Channel Type
            </h4>
            <p class="category font-weight-thin">
              Edit Payment Channel Type
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="localPaymentChannelType.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"  
                label="Name"
              />
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      paymentChannelType: Object,
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,

        localPaymentChannelType: '',
      }
    },
    computed: {
      isDataChanged () {
        return _.isEqual(this.paymentChannelType, this.localPaymentChannelType)
      },
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.localPaymentChannelType = { ...this.paymentChannelType }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            if (!this.isDataChanged) {
              this.$api.paymentChannelTypes().update(this.localPaymentChannelType.id, this.prepareFormData())
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ color: 'success', message: response.data.message })

                    this.dialog = false
                  }
                }).catch((err) => {
                  console.log(err)
                  this.$snack({ color: 'error', message: err.response.statusText })
                }).then(() => {
                  this.progressing = false
                })
            } else {
              this.$snack({ color: 'warning', message: 'No update has been done' })
              this.progressing = false
              this.dialog = false
            }
          })
      },
      prepareFormData () {
        return {
          name: this.localPaymentChannelType.name,
        }
      },
    },
  }
</script>
